<template>
  <div>
    <header>
      <h2>Edit header</h2>
    </header>
    <main class="content">
      <section class="input-section">
        <HeaderForm
          :header-prop="header"
          button-title="Update Header"
          @validated="updateHeader()" />
        <b-button
          v-if="!confirm"
          class="delete-button"
          type="is-warning"
          @click="confirm=true">
          Delete Header
        </b-button>
        <b-button
          v-if="confirm"
          class="delete-button"
          type="is-danger"
          @click="deleteHeader">
          Confirm deletion
        </b-button>
      </section>
      <section class="preview">
        <h3>Preview</h3>
        <div class="field">
          <b-field
            label="Tablet preview">
            <b-switch v-model="tablet" />
          </b-field>
        </div>
        <div
          v-if="!tablet"
          class="header mobile">
          <div :class="['top-bar', header.logoColor]">
            <button
              class="settings-button">
              <svg class="settings-icon" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path fill="none" d="M0 0h20v20H0V0z"/><path d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 00-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"/></svg>
            </button>
            <svg class="s-logo" svg-inline="" data-omni-type="microsite" data-omni="nl:welcome:logo" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.9 24.8"><path class="st0" d="M90.7 12.2s-1.6-1-2.5-1.3c0 0-3-1.4-3.6-2 0 0-1.2-1.1-.5-2.4 0 0 .3-.8 1.5-.8 0 0 1.6.1 1.6 1.4V9H93V6.3s.4-4.5-6.8-4.7c0 0-5.7-.4-7.3 2.7 0 0-.6.7-.6 3V9s-.1 2 .9 3.2c0 0 .6.8 2 1.8 0 0 2.9 1.5 4.6 2.4 0 0 1.7 1 1.5 2.6 0 0-.1 1.6-1.8 1.5 0 0-1.5-.1-1.5-1.6V17h-6.1v2.7s-.2 5.2 7.7 5.2c0 0 7.5.2 7.9-5.3v-2.2c-.1-.1.2-3.4-2.8-5.2zM61.4 2.1l-1.9 12.1H59l-1.8-12h-9.6L47.1 24h5.7l.1-16.4h.4l3 16.4h6l2.9-16.4h.4l.2 16.4h5.7l-.6-21.9h-9.5zM27.6 2.2L23.9 24H30l2.2-16.9h.5L34.9 24H41L37.3 2.2h-9.7zM155.7 11.9v3.2h1.6v3.4c0 1.7-1.4 1.7-1.4 1.7-1.8 0-1.7-1.6-1.7-1.6V6.8c0-1.2 1.6-1.3 1.6-1.3 1.5 0 1.5 1.5 1.5 1.5v1.8h5.7c.2-3.5-.5-4.4-.5-4.4-1.4-3.2-6.8-3-6.8-3-8.3 0-7.4 6.4-7.4 6.4v11.5c.2 6 8.3 5.4 8.5 5.4 3.6-.4 4.7-1.6 4.7-1.6 1-.8 1.3-1.8 1.3-1.8.3-.6.4-2.5.4-2.5V12h-7.5v-.1zM136.7 15.5h-.3l-5.8-13.4h-7V24h5.7l-.4-13.3h.3l6 13.3h6.8V2.1h-5.7l.4 13.4zM109.7 18.6s.1 1.8-1.6 1.8c0 0-1.8.1-1.8-1.8V2.1h-6.2v16.3s-.6 6.2 8.1 6.2c0 0 7.6.1 7.6-5.9V2.1h-6.1v16.5zM15.7 12.2s-1.6-1-2.5-1.3c0 0-3-1.4-3.6-2 0 0-1.2-1.1-.5-2.4 0 0 .3-.8 1.5-.8 0 0 1.6.1 1.6 1.4V9H18V6.3s.4-4.5-6.8-4.7H9.9S5.5 1.8 4 4.2c0 0-.6.7-.6 3v1.7s-.1 2 .9 3.2c0 0 .6.8 2 1.8 0 0 2.8 1.5 4.6 2.4 0 0 1.7 1 1.5 2.6 0 0-.1 1.6-1.8 1.5 0 0-1.5-.1-1.5-1.6v-1.9H2.9v2.7s-.2 5.2 7.7 5.2c0 0 7.5.2 7.9-5.3v-2.2c-.1 0 .2-3.3-2.8-5.1z"/></svg>
          </div>
          <div
            id="updates-category"
            class="updates-card main-card">
            <div
              class="header-content"
              :style="`background-image: url(${header.imageUrl})`">
              <div
                v-if="header.topFade"
                class="top-story-overlay" />
              <div
                v-if="header.botFade"
                class="bot-story-overlay" />
              <a
                :class="['cta-btn-header', header.buttonColor]"
                :href="header.url">{{ header.buttonText }}</a>
            </div>
          </div>
          <div class="bottom-bar">
            <div class="search-input-container">
              <input
                class="search-input"
                type="text"
                autocomplete="off"
                placeholder="Zoek op Google">
              <button
                class="submit-search"
                data-omni-type="microsite"
                data-omni="nl:welcome:search:submit:click">
                <img
                  class="search-icon"
                  svg-inline>
              </button>
            </div>
          </div>
        </div>

        <div
          v-else
          class="header tablet">
          <div :class="['top-bar', header.logoColor]">
            <button
              class="settings-button">
              <svg class="settings-icon" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20"><path fill="none" d="M0 0h20v20H0V0z"/><path d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 00-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"/></svg>
            </button>
            <svg class="s-logo" svg-inline="" data-omni-type="microsite" data-omni="nl:welcome:logo" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165.9 24.8"><path class="st0" d="M90.7 12.2s-1.6-1-2.5-1.3c0 0-3-1.4-3.6-2 0 0-1.2-1.1-.5-2.4 0 0 .3-.8 1.5-.8 0 0 1.6.1 1.6 1.4V9H93V6.3s.4-4.5-6.8-4.7c0 0-5.7-.4-7.3 2.7 0 0-.6.7-.6 3V9s-.1 2 .9 3.2c0 0 .6.8 2 1.8 0 0 2.9 1.5 4.6 2.4 0 0 1.7 1 1.5 2.6 0 0-.1 1.6-1.8 1.5 0 0-1.5-.1-1.5-1.6V17h-6.1v2.7s-.2 5.2 7.7 5.2c0 0 7.5.2 7.9-5.3v-2.2c-.1-.1.2-3.4-2.8-5.2zM61.4 2.1l-1.9 12.1H59l-1.8-12h-9.6L47.1 24h5.7l.1-16.4h.4l3 16.4h6l2.9-16.4h.4l.2 16.4h5.7l-.6-21.9h-9.5zM27.6 2.2L23.9 24H30l2.2-16.9h.5L34.9 24H41L37.3 2.2h-9.7zM155.7 11.9v3.2h1.6v3.4c0 1.7-1.4 1.7-1.4 1.7-1.8 0-1.7-1.6-1.7-1.6V6.8c0-1.2 1.6-1.3 1.6-1.3 1.5 0 1.5 1.5 1.5 1.5v1.8h5.7c.2-3.5-.5-4.4-.5-4.4-1.4-3.2-6.8-3-6.8-3-8.3 0-7.4 6.4-7.4 6.4v11.5c.2 6 8.3 5.4 8.5 5.4 3.6-.4 4.7-1.6 4.7-1.6 1-.8 1.3-1.8 1.3-1.8.3-.6.4-2.5.4-2.5V12h-7.5v-.1zM136.7 15.5h-.3l-5.8-13.4h-7V24h5.7l-.4-13.3h.3l6 13.3h6.8V2.1h-5.7l.4 13.4zM109.7 18.6s.1 1.8-1.6 1.8c0 0-1.8.1-1.8-1.8V2.1h-6.2v16.3s-.6 6.2 8.1 6.2c0 0 7.6.1 7.6-5.9V2.1h-6.1v16.5zM15.7 12.2s-1.6-1-2.5-1.3c0 0-3-1.4-3.6-2 0 0-1.2-1.1-.5-2.4 0 0 .3-.8 1.5-.8 0 0 1.6.1 1.6 1.4V9H18V6.3s.4-4.5-6.8-4.7H9.9S5.5 1.8 4 4.2c0 0-.6.7-.6 3v1.7s-.1 2 .9 3.2c0 0 .6.8 2 1.8 0 0 2.8 1.5 4.6 2.4 0 0 1.7 1 1.5 2.6 0 0-.1 1.6-1.8 1.5 0 0-1.5-.1-1.5-1.6v-1.9H2.9v2.7s-.2 5.2 7.7 5.2c0 0 7.5.2 7.9-5.3v-2.2c-.1 0 .2-3.3-2.8-5.1z"/></svg>
          </div>
          <div
            id="updates-category"
            class="updates-card main-card">
            <div
              class="header-content"
              :style="`background-image: url(${header.imageUrlTablet})`">
              <div
                v-if="header.topFade"
                class="top-story-overlay" />
              <div
                v-if="header.botFade"
                class="bot-story-overlay" />
              <a
                :class="['cta-btn-header', header.buttonColor]"
                :href="header.url">{{ header.buttonText }}</a>
            </div>
          </div>
          <div class="bottom-bar">
            <div class="search-input-container">
              <input
                class="search-input"
                type="text"
                autocomplete="off"
                placeholder="Zoek op Google">
              <button
                class="submit-search"
                data-omni-type="microsite"
                data-omni="nl:welcome:search:submit:click">
                <img
                  class="search-icon"
                  svg-inline>
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { db, firebase } from "../../firebase";
import HeaderForm from "../../components/HeaderForm.vue";

export default {
  name: "CreateHeader",
  components: { HeaderForm },
  data() {
    return {
      dbKey: "headers",
      doc: "",
      confirm: false,
      tablet: false,
      swag: "",
      header: {
        title: "",
        buttonText: "",
        url: "",
        imageUrl: "",
        imageUrlTablet: "",
        buttonColor: "white",
        botFade: false,
        topFade: false
      },
      headers: []
    };
  },
  firestore: {
    headers: db.collection("headers")
  },
  created() {
    const docNo = window.location.hash.split("id=")[1];
    this.doc = docNo;
    this.getDoc();
  },
  beforeCreate() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    getDoc() {
      const docRef = db.collection(this.dbKey).doc(this.doc);
      docRef
        .get()
        .then(doc => {
          if (doc.exists) {
            this.header = doc.data();
            if (this.header.endDate) {
              this.header.endDate = this.header.endDate.toDate();
              this.header.startDate = this.header.startDate.toDate();
            }
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },
    updateHeader() {
      db.collection(this.dbKey)
        .doc(this.doc)
        .set(this.header)
        .then(() => {
          this.$toast.open({
            message: "Header has been updated",
            type: "is-success",
            position: "is-bottom"
          });
          console.log("Document successfully written!");
        })
        .catch(error => {
          console.error("Error writing document: ", error);
        });
    },
    deleteHeader() {
      db.collection(this.dbKey)
        .doc(this.doc)
        .delete()
        .then(() => {
          this.$router.push("/headers");
          console.log("Document successfully deleted!");
        })
        .catch(error => {
          console.error("Error writing document: ", error);
        });
    }
  }
};
</script>

<style lang="scss">
h2 {
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0 1em 0;
}

.delete-button {
  margin-top: 1rem;
}
</style>